import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {animate} from '@angular/animations';
import { ClientsService } from './clients.service';
import { ClientModel } from '../../models/survey/survey.model';
import { AuthTokenService } from '../../shared/services/auth-token.service';
import { PreviousUrlService } from '../../shared/services/previous-url.service';

@Component({
  selector: 'app-clients',
  templateUrl: './clients.component.html',
  styleUrls: ['./clients.component.less'],
  animations: animate['slideInOutAnimation'],
})
export class ClientsComponent implements OnInit {

  clients: ClientModel[];
  visibleCliens: ClientModel[];
  filter: boolean;
  column: string;
  isDesc: boolean;
  searchText: string;
  loader: boolean;

  constructor(private router: Router, private shareService: PreviousUrlService, private clientsService: ClientsService) {
  }

  ngOnInit() {
    if (!AuthTokenService.isAdmin()) {
      this.router.navigate(['/surveys']);
    }
    this.shareService.setSurveyTitle('Clients');
    this.filter = false;
    this.column = 'name';
    this.isDesc = true;

    this.loader = true;
    this.clientsService.getAll().subscribe(
      (response) => {
        this.loader = false;
        this.clients = response;
        this.visibleCliens = this.clients.slice(0);
      },
      (error) => {
      }
    );
  }

  filterClients(filter) {
    if (filter === '' || filter === null) {
      this.visibleCliens = this.clients.slice(0);
    }
    else {
      this.visibleCliens = this.clients.filter(
        client => {
          return (
            client.name.toLowerCase().includes(filter.toLowerCase())
          );
        })
    }
  }

  sort(client) {
    this.isDesc = !this.isDesc;
    this.column = client;
    const direction = this.isDesc ? 1 : -1;

    this.visibleCliens.sort(function (a, b) {
      if (client === 'expiryDate') {
        const dateA = new Date(a[client]).getTime(), dateB = new Date(b[client]).getTime();
        if (dateA < dateB) {
            return -1 * direction;
        }
        else if (dateA > dateB) {
            return 1 * direction;
        }
        else {
            return 0;
        }
      } else {
        if (a[client] < b[client]) {
            return -1 * direction;
        }
        else if (a[client] > b[client]) {
            return 1 * direction;
        }
        else {
            return 0;
        }
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/routes/clients/clients.component.ts